import React from 'react';
import FilerobotImageEditor, { TABS, TOOLS } from 'react-filerobot-image-editor';
import { PDFImageProps } from '../../utils/models';

import { base64Upload } from '../../services/fileUpload';

interface SavedImage {
	extension: string;
	fullName: string;
	height: number;
	width: number;
	imageBase64: string;
	mimeType: string;
	name: string;
	quality: number;
}

interface ImageEditorProps {
	image: PDFImageProps;
	onCloseEditor: () => void;
	onEditImage: (image: PDFImageProps) => void;
}

const ImageEditor: React.FC<ImageEditorProps> = ({ image, onCloseEditor, onEditImage }) => {
	const handleImageEdit = async (savedImage: SavedImage) => {
		const imageSource = await base64Upload(savedImage.name, savedImage.imageBase64);

		const newFile: PDFImageProps = {
			refNo: image.refNo,
			src: imageSource ? imageSource : savedImage.imageBase64,
			caption: savedImage.name,
			format: savedImage.extension,
		};

		onEditImage(newFile);
		onCloseEditor();
	};

	return (
		<FilerobotImageEditor
			useBackendTranslations={false}
			source={image.src}
			onClose={onCloseEditor}
			onSave={handleImageEdit}
			annotationsCommon={{ fill: '#ff0000' }}
			Text={{ text: 'Filerobot...' }}
			Rotate={{ angle: 90, componentType: 'slider' }}
			Crop={{
				presetsItems: [
					{
						titleKey: 'classicTv',
						descriptionKey: '4:3',
						ratio: 4 / 3,
						// icon: CropClassicTv, // optional, CropClassicTv is a React Function component. Possible (React Function component, string or HTML Element)
					},
					{
						titleKey: 'cinemascope',
						descriptionKey: '21:9',
						ratio: 21 / 9,
						// icon: CropCinemaScope, // optional, CropCinemaScope is a React Function component.  Possible (React Function component, string or HTML Element)
					},
				],
				presetsFolders: [
					{
						titleKey: 'socialMedia', // will be translated into Social Media as backend contains this translation key
						// icon: Social, // optional, Social is a React Function component. Possible (React Function component, string or HTML Element)
						groups: [
							{
								titleKey: 'facebook',
								items: [
									{
										titleKey: 'profile',
										width: 180,
										height: 180,
										descriptionKey: 'fbProfileSize',
									},
									{
										titleKey: 'coverPhoto',
										width: 820,
										height: 312,
										descriptionKey: 'fbCoverPhotoSize',
									},
								],
							},
						],
					},
				],
			}}
			tabsIds={[TABS.ADJUST, TABS.ANNOTATE, TABS.WATERMARK]} // or {['Adjust', 'Annotate', 'Watermark']}
			defaultTabId={TABS.ANNOTATE} // or 'Annotate'
			defaultToolId={TOOLS.TEXT} // or 'Text'
		/>
	);
};

export default ImageEditor;
